import { useDeleteLineType } from "./api/deleteLineType";
import { Button } from "reactstrap";


const DeleteLineType = ({handleCloseModal, lineTypeId}: DeleteLineTypeProps)  => {
  
  const deleteLineTypeMutation = useDeleteLineType({ lineTypeId});
  const handleSubmit = async (): Promise<void> => {
    deleteLineTypeMutation.mutateAsync({ 
      lineTypeId: lineTypeId
    })

    handleCloseModal();
  }

  return (
    <>
        <label>Είστε σίγουροι οτι θέλετε να διαγράψετε το Είδος Γραμμής;</label>
        <div>
          <Button style={{ margin: "10px" }} onClick={handleCloseModal}>Ακύρωση</Button>
          <Button style={{ margin: "10px" }} color='danger' onClick={handleSubmit}>Διαγραφή</Button>
        </div>
    </>
  )
}

interface DeleteLineTypeProps{
  lineTypeId: number;
  handleCloseModal: () => void;
}

export default DeleteLineType;